import { ButtonHTMLAttributes, FC } from 'react';

import { IconType } from 'react-icons';

import { Container } from './styles';

interface ButtonLinkProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  icon?: IconType;
}

export const ButtonLink: FC<ButtonLinkProps> = ({
  title,
  icon: Icon,
  ...props
}) => {
  return (
    <Container {...props}>
      {!!Icon && <Icon />}

      <span>{title}</span>
    </Container>
  );
};
